module.exports = __webpack_public_path__ + "img/reviews-image3.feff71fb.jpg";